module.exports = __webpack_public_path__ + "img/38400.24ddbe07.jpg";